import styled, { CSSProperties } from 'styled-components/macro'

export const StyledBox = styled.div<{ jsStyles: CSSProperties }>`
  ${(p) => (p.jsStyles ? { ...p.jsStyles } : {})}
`
